/**
 * Shared GSAP + ScrollTrigger setup.
 * Dynamically imports both to avoid SSR issues.
 * Returns { gsap, ScrollTrigger } once loaded.
 */

let gsapReady: Promise<{
  gsap: typeof import('gsap').default;
  ScrollTrigger: typeof import('gsap/ScrollTrigger').default;
}> | null = null;

export function getGsap() {
  if (!gsapReady) {
    gsapReady = Promise.all([
      import('gsap'),
      import('gsap/ScrollTrigger'),
    ]).then(([gsapModule, stModule]) => {
      const gsap = gsapModule.default;
      const ScrollTrigger = stModule.default;
      gsap.registerPlugin(ScrollTrigger);
      return { gsap, ScrollTrigger };
    });
  }
  return gsapReady;
}
